import { ShieldCheck, Check } from 'lucide-react';

export function PrivacyPromise() {
  return (
    <div className="rounded-2xl border-2 border-brand-200 bg-linear-to-br from-brand-50 via-white to-emerald-50/40 p-5 shadow-sm">
      <div className="flex items-start gap-3">
        <div className="flex size-11 shrink-0 items-center justify-center rounded-xl bg-linear-to-br from-brand-500 to-brand-700 text-white shadow-md ring-2 ring-brand-200">
          <ShieldCheck className="size-5" aria-hidden="true" />
        </div>
        <div className="flex-1">
          <p className="text-base font-bold text-slate-900">
            We Protect Your Privacy
          </p>
          <ul className="mt-2 grid gap-1.5">
            <li className="flex items-center gap-2 text-sm">
              <Check
                className="size-4 shrink-0 text-brand-600"
                aria-hidden="true"
              />
              <span className="font-semibold text-slate-800">
                Used only for enrollment
              </span>
            </li>
            <li className="flex items-center gap-2 text-sm">
              <Check
                className="size-4 shrink-0 text-brand-600"
                aria-hidden="true"
              />
              <span className="font-semibold text-slate-800">
                We don&apos;t sell your info
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}